import { Directive, HostListener } from '@angular/core';

declare var UIkit: any;

@Directive({
    selector: '[appSlider]',
    exportAs: 'appSlider',
    standalone: false
})
export class SliderDirective {

    @HostListener('window:resize') onResize() {
        this.checkActiveSlider();
    }
    constructor() { }

    ngOnInit() {
        this.checkActiveSlider();
    }

    checkActiveSlider() {
        const windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
        if (windowWidth >= 960) {
            UIkit.slider('.js-slider', {
                finite: true,
                draggable: false
            });
        } else {
            UIkit.slider('.js-slider', {
                finite: true,
                draggable: true
            });
        }
    }

}
